import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { OrganisationService } from '@src/core/services';
import { LoyaltyCodesForProductView } from '@src/api';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LpDiscountDialogService } from '../../services';
import { LoyaltyProgramProductDiscountType } from '../../models';

@Component({
  selector: 'lp-product-code-card',
  templateUrl: './product-code-card.component.html',
  styleUrls: ['./product-code-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCodeCardComponent extends BaseResizableComponent {
  private readonly organisationService = inject(OrganisationService);
  private readonly lpDiscountDialogService = inject(LpDiscountDialogService);

  @Input() code?: LoyaltyCodesForProductView;
  @Input() loading = false;

  /** Признак использования unionId в запросах */
  useUnionId = false;

  /** ID ассоциации внешней базы */
  get externalUnionId(): string | undefined {
    return this.useUnionId ? this.code?.parentOrganisationId : undefined;
  }

  get discountType(): LoyaltyProgramProductDiscountType {
    if (this.code?.discountAbsolute) {
      return 'cash';
    } else if (this.code?.discountText) {
      return 'tag';
    }

    return 'rate';
  }

  get discount() {
    return this.code?.discountRate ?? this.code?.discountAbsolute ?? this.code?.discountText ?? 0;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.organisationService.currentParentOrganisation$.subscribe(() => {
      this.setUseUnionId();
    });
  }

  /** Заполняем признак использования unionId */
  setUseUnionId() {
    this.useUnionId = this.code?.isAdvertisment
      ? this.organisationService.currentParentOrganisation$.value?.id !== this.code.parentOrganisationId
      : false;
  }

  showProductCode() {
    if (!this.code) return;

    this.lpDiscountDialogService.openDiscountDialogByCode(this.code);
  }
}
